import React from 'react';
import { Routes, Route } from "react-router-dom";

import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import '../assets/fonts/font.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import "../assets/style/style.css";
import "../assets/style/responsive.css";
import 'react-toastify/dist/ReactToastify.css';


import Login from '../auth/Login';
import ForgotPassword from '../auth/ForgotPassword';
import ResetPassword from '../auth/ResetPassword';

import Home from './Home/Home';
import Case from './Case/Case';
import NewCase from './Case/NewCase';
import Profile from './Profile/Profile';
import ChangePassword from './ChangePassword/ChangePassword';
import Error from './Error/Error';

import VoiceInputs from './VoiceInputs/VoiceInputs';


const Main = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route exact path="/forgot-password" element={<ForgotPassword />} />
        <Route exact path="/reset-password/:token" element={<ResetPassword />} />
        <Route exact path="/profile" element={<Profile />} />
        <Route exact path="/change-password" element={<ChangePassword />} />
        <Route exact path="/home" element={<Home />} />
        <Route exact path="/case/:id" element={<Case />} />
        <Route exact path="/case" element={<NewCase />} />
        <Route exact path="/voice-input" element={<VoiceInputs />} />


        <Route exact path="*" element={<Error />} />
      </Routes>
    </React.Fragment>
  );
}

export default Main